interface IdIterator {
  (f?: false): {
    stop: () => void;
    create: () => number | void;
  };
  (f: true): {
    create: () => number;
  };
}

const createIdIterator = ((forever?: boolean) => {
  let id = 0;
  let flag = true;
  const stop = () => (flag = false);
  const create = () => {
    if (!flag) {
      throw 'id iterator stopped';
    }
    id++;
    return id;
  };
  if (forever) {
    return { create };
  } else {
    return { stop, create };
  }
}) as never as IdIterator;

const { create: globalCreate } = createIdIterator(true);
export const useGlobalId = () => {
  return globalCreate();
};

export const useId = () => {
  return createIdIterator();
};
